export default "__VITE_ASSET__B0ghCoN7__"